<template>
<div id="top">

  <div id="carousel-example-1z" class="top_head_margin slide carousel-fade" data-ride="carousel">
    <div class="view" style="">

      <img class="pc-only-i main_image" src="/static/img/pc-main.png" style="width: 100%;height: auto;">
      <img class="sp-only-i main_image" src="/static/img/sp-main.png" style="width: 100%;height: auto;">

      <div id="search_box_pc"><!--  class="d-pc" -->
        <div class="form-group search_form mt-3">
          <div class="">
            <div class="search_width mx-auto p-1" style="width: 30%;position: relative;">
              <div class="m-0 row">
                <div class="col-6 px-0">
                  <div class="cp_ipselect cp_sl01">
                    <select v-model="search_category" @change="change_search_category" style="px-1 m-0 d-inline form-control">
                      <option v-for="(item, index) in category" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-6 px-0">
                <div class="cp_ipselect cp_sl01">
                  <select v-model="search_region" class="px-1 m-0 d-inline form-control">
                    <option v-for="(item, index) in search_region_arr" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                  </select>
                </div>
                <div class="" style="position: absolute;top: 0px;right: -40px;">
                  <span class="m-0">
                    <img id="" @click="search_exec" class="search_exec_pc p-1 m-0 search_icon pointer" src="/static/img/icon/search.png">
                  </span>
                </div>
              </div>
            </div>
            <div class="m-0 mt-1 row">
              <div class="col-md-12 px-0">
                <a style="background: #fff;display: block;margin: 0.1px;text-align: center;font-size: 0.9rem;padding: 4px;color: #747474;border: solid 1px #e5913b;border-radius: 6px;background: #e5b473;color: #fff;font-weight: bold;" href="javascript:void(0);"  class="mt-2 py-2" @click="search_modal_disp = true">
                  <img style="border-radius: 6px;display: inline;" src="/static/img/top_search_detail.png">
                  <span>フリーワード、希望条件から探してみる</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="py-2 text-center" style="color: #848484!important;background-color: #fff5df;">
    <div class="row mx-auto">
      <div class="col-md-6 pc-r sp-c">
        <span style="font-size: 0.8rem;vertical-align: super;">日本初！</span>
        <span class="pl-2" style="font-size: 1rem;"><a style="font-size: 1.5rem;color: #848484!important;" href="/about_piachu">ピアチュウとは？</a></span>
      </div>
      <div class="pt-1 col-md-6 pc-l sp-c">
        <span class="pl-2" style="font-size: 1rem;"><a style="vertical-align: sub;color: #848484!important;" href="/guideline_user">●使い方について</a></span>
        <span class="pl-2" style="font-size: 1rem;"><a style="vertical-align: sub;color: #848484!important;" href="/charge_user">●利用料について</a></span>
      </div>
    </div>
  </div>

  <div class="top container px-3 p-md-0">

      <!--
      <router-link :to="'/search'">検索</router-link>
      <router-link :to="'/article'">企画・特集</router-link>
      <router-link :to="{ path: '/ranking', query: { type: '1' }}">ランキング（販売者）</router-link>
      <router-link :to="{ path: '/ranking', query: { type: '2' }}">ランキング（ピアノ）</router-link>
      -->

      <section class="pt-5 wow fadeIn">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">カテゴリー</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>

                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(category, index) in categories">
                  <a href="javascript:void(0);" @click="jumpSearchCategory(category['no'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;position: relative;">
                        <img class="" :src="category['img']" alt="" style="height: 170px;">
                        <span style="position: absolute;bottom: 16px;z-index: 10000000000000000000;right: 5px;font-weight: bold;">{{ category['name'] }}</span>
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                          <span>{{ category['content'] }}</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">有名ブランド</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>

                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(brand1, index) in brands1">
                  <a href="javascript:void(0);" @click="jumpSearchBrand(brand1['no'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;position: relative;">
                        <img class="" :src="brand1['img']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                          <span>{{ brand1['name'] }}</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>

            <!-- Contents -->
            <div style="overflow: hidden;" class="mt-4">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>

                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(brand2, index) in brands2">
                  <a href="javascript:void(0);" @click="jumpSearchBrand(brand2['no'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;position: relative;">
                        <img class="" :src="brand2['img']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                          <span>{{ brand2['name'] }}</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>

          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="check_piano.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">最近チェックしたピアノ</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in check_piano">
                  <a href="javascript:void(0);" @click="jumpProduct(product['id'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image1']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                          <span><strong>{{ get_hash_value(brand, product['brand']) }} {{ product['model_number'] }}</strong></span>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                            <span style="color: red;">価格(税込){{ number_format(Math.floor(product['price'] * 1.1)) }}円</span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12">
                          <p class="m-0">販売者： 
                            <span v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</span>
                            <span v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</span>
                            <span>({{ cinit(product['region'], '-') }} {{ cinit(product['address_1'], '-') }})</span>
                          </p>
                          <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['seller_evaluation']"></star-rating>
                          <div class="row my-1">
                            <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                              <span>{{ product['slogan'] }}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <!--
            <div class="my-3 row">
              <div class="col-md-12">
                <a href="javascript:pref_search();" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
            -->
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="new_piano.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">新着（ピアノ）</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in new_piano">
                  <a href="javascript:void(0);" @click="jumpProduct(product['id'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image1']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                          <span><strong>{{ get_hash_value(brand, product['brand']) }} {{ product['model_number'] }}</strong></span>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                            <span style="color: red;">価格(税込){{ number_format(Math.floor(product['price'] * 1.1)) }}円</span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12">
                          <p class="m-0">販売者： 
                            <span v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</span>
                            <span v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</span>
                            <span>({{ cinit(product['region'], '-') }} {{ cinit(product['address_1'], '-') }})</span>
                          </p>
                          <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['seller_evaluation']"></star-rating>
                          <div class="row my-1">
                            <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                              <span>{{ product['slogan'] }}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <div class="my-3 row">
              <div class="col-md-12 text-right">
                <a href="javascript:void(0);" @click="jumpProductNew" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="new_seller.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">新着（販売者）</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in new_seller">
                  <a href="javascript:void(0);" @click="jumpSeller(product['id'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image1']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12" style="max-width: 240px;">
                          <p class="m-0">販売者： 
                            <span v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</span>
                            <span v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</span>
                            <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['evaluation']"></star-rating>
                          </p>
                          <span>{{ cinit(product['region'], '-') }} ({{ cinit(product['address_1'], '-') }})</span>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12">
                          <div class="row my-1">
                            <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                              <span>{{ product['slogan'] }}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12" style="max-width: 240px;">
                            <p class="m-0">販売中のピアノ: {{ product['now_sell_num'] }}台</p>
                            <p class="m-0">過去の販売ピアノ: {{ product['sell_num'] }}台</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <div class="my-3 row">
              <div class="col-md-12 text-right">
                <a href="javascript:void(0);" @click="jumpSellerNew" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="ranking_seller.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">人気ランキング（販売者）</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in ranking_seller">
                  <a href="javascript:void(0);" @click="jumpSeller(product['id'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image1']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12" style="max-width: 240px;">
                          <p class="m-0">販売者： 
                            <span v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</span>
                            <span v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</span>
                            <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['evaluation']"></star-rating>
                          </p>
                          <span>{{ cinit(product['region'], '-') }} ({{ cinit(product['address_1'], '-') }})</span>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12">
                          <div class="row my-1">
                            <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                              <span>{{ product['slogan'] }}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12" style="max-width: 240px;">
                            <p class="m-0">販売中のピアノ: {{ product['now_sell_num'] }}台</p>
                            <p class="m-0">過去の販売ピアノ: {{ product['sell_num'] }}台</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <div class="my-3 row">
              <div class="col-md-12 text-right">
                <a href="javascript:void(0);" @click="jumpSellerRanking" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="ranking_piano.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">人気ランキング（中古ピアノ）</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in ranking_piano">
                  <a href="javascript:void(0);" @click="jumpProduct(product['id'])" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image1']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                          <span><strong>{{ get_hash_value(brand, product['brand']) }} {{ product['model_number'] }}</strong></span>
                        </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text" style="max-width: 240px;">
                            <span style="color: red;">価格(税込){{ number_format(Math.floor(product['price'] * 1.1)) }}円</span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                        <div class="col-md-12">
                          <p class="m-0">販売者： 
                            <span v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</span>
                            <span v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</span>
                            <span>({{ cinit(product['region'], '-') }} {{ cinit(product['address_1'], '-') }})</span>
                          </p>
                          <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['seller_evaluation']"></star-rating>
                          <div class="row my-1">
                            <div class="col-md-12 ellipsis_text" style="max-width: 240px;white-space: break-spaces;height: 3.5rem;">
                              <span>{{ product['slogan'] }}</span>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <div class="my-3 row">
              <div class="col-md-12 text-right">
                <a href="javascript:void(0);" @click="jumpProductRanking" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="article.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">企画・記事</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in article">
                  <a @click="jumpArticle(product['id'])" href="javascript:void(0);" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <!--<div class="card-img-best-parent text-center center-block" style="min-height: 160px;max-height: 160px;">
                        <img class="card-img-best" :src="product['main_image']" alt="">
                      </div>-->
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['main_image']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text text-center" style="max-width: 240px;">
                            <span><strong>{{ product['title'] }}</strong></span>
                          </div>
                        </div>
                        <div class="row my-1">
                          <div class="col-md-12 text-center">
                            <span class="text_3_min" style="max-width: 220px;">{{ product['slogan'] }}</span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text text-center" style="max-width: 240px;">
                            <span><strong>{{ product['writer_name'] }}</strong></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <div class="my-3 row">
              <div class="col-md-12 text-right">
                <a href="javascript:void(0);" @click="jumpArticleMore" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="ranking_article.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">記事ランキング</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in ranking_article">
                  <a @click="jumpArticleDetail(product['id'])" href="javascript:void(0);" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card pt-3 px-3" style="max-width: max-content;">
                      <!--<div class="card-img-best-parent text-center center-block" style="min-height: 160px;max-height: 160px;">
                        <img class="card-img-best" :src="product['main_image']" alt="">
                      </div>-->
                      <div class="text-center center-block" style="max-height: 160px;min-height: 160px;max-width: 220px;min-width: 220px;overflow: hidden;">
                        <img class="" :src="product['image_01']" alt="">
                      </div>
                      <div class="card-body p-0 pt-2">
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text text-center" style="max-width: 240px;">
                            <span><strong>{{ product['title'] }}</strong></span>
                          </div>
                        </div>
                        <div class="row my-1">
                          <div class="col-md-12 text-center">
                            <span class="text_3_min" style="max-width: 220px;">{{ product['explanatory_text'] }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <!--
            <div class="my-3 row">
              <div class="col-md-12">
                <a href="javascript:pref_search();" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
            -->
          </div>
        </div>
      </section>

      <section class="pt-5 wow fadeIn" v-if="new_review.length > 0">
        <div class="row">
          <div class="col-md-12 mb-1">
            <h4 class="text-color-1 mb-3"><span class="d-block">新着評価</span></h4>
            <!-- Contents -->
            <div style="overflow: hidden;">
            <div class="table-responsive">
            <table class="table">
              <thead></thead>
              <tbody>
              <tr>
                <td class="py-0" style="border-top: 0px;background: #fff;" v-for="(product, index) in new_review">
                  <a href="javascript:void(0);" class="col-3 center-block mb-3" style="color: #676460;">
                    <div class="card py-3 px-3" style="max-width: max-content;">
                      <div class="card-body p-0 pt-2">
                        <div class="row my-1">
                          <div class="col-md-12 ellipsis_text text-left" style="max-width: 240px;">
                            <span><strong>{{ product['nickname'] }} {{ get_hash_value(gender, product['gender']) }}</strong></span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 text-center">
                            <span class="text_6_min" style="max-width: 220px;">{{ product['contents'] }}</span>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row my-1">
                          <div class="col-md-12 text-left">
                            <p class="m-0" v-if="product['legal_person']==1">{{ cinit(product['corp_name'], '-') }}</p>
                            <p class="m-0" v-else-if="product['legal_person']==0">{{ cinit(product['store_name'], '-') }}</p>
                            <a href="javascript:void(0);" @click="jumpSeller(product['sellers_id'])">販売者の詳細</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </td>

              </tr>
              </tbody>
            </table>
            </div>
            </div>
            <!-- Contents -->
            <!--
            <div class="my-3 row">
              <div class="col-md-12">
                <a href="javascript:pref_search();" class="mr-3 more_btn pull-right">もっと見る</a>
              </div>
            </div>
            -->
          </div>
        </div>
      </section>

  </div>

  <div id="overlay" class="search" style="" v-show="search_modal_disp">
    <b-container style="">
      <div class="search_modal card text-left m-auto" style="overflow: auto;max-width: 640px;padding: 30px;position: relative;">

        <span @click="search_modal_disp = false" style="font-size: 1.2rem;position: absolute;font-weight: bold;top: 2px;right: 0px;background-color: rgb(250, 181, 98);padding: 16px 19px;border-radius: 50%;z-index: 2147483647;">×</span>

        <div class="col-md-12">
    
          <div class="col-sm-12 control-label text-left p-0 mt-3">
            <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">カテゴリ</span>
          </div>
    
          <div class="row">
            <div class="col-md-12 px-2 pt-0">
              <div class="main_search_type top_modal row p-3 mb-5">
                <input type="radio" v-model="main_search_type" id="select1" value="1" checked>
                <label class="col-6" for="select1">ピアノ</label>
                <input type="radio" v-model="main_search_type" id="select2" value="2">
                <label class="col-6" for="select2">販売者</label>
              </div>
            </div>
          </div>

          <div class="search_word_disp col-sm-12 control-label text-left p-0">
            <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">フリーワード</span>
          </div>

          <div class="search_word_disp row">
            <div class="col-md-12 px-2 pt-0">
              <input placeholder="" class="form-control" style="padding: .25rem!important" v-model="search_word" type="text" value="">
            </div>
          </div>

          <div class="sort_disp col-sm-12 mt-3 control-label text-left p-0">
            <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">並び替え</span>
          </div>

          <template v-if="String(main_search_type) == '1'">

            <div class="sort_disp row">
              <div class="col-md-12 px-2 pt-0">
                <select class="form-control" v-model="search_sort_type">
                  <option v-for="(item, index) in sort_type_product" :value="item.no" :key="`sort_type-${item.no}`">{{ item.name }}</option>
                </select>
              </div>
            </div>

            <div class="subject_gender_disp col-sm-12 mt-3 control-label text-left p-0">
              <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">タイプからしぼる</span>
            </div>

            <div class="subject_gender_disp row">
              <div class="col-md-12 px-2 pt-0">
                <select class="form-control" v-model="search_type">
                  <option v-for="(item, index) in type" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                </select>
              </div>
            </div>

            <div class="subject_gender_disp col-sm-12 mt-3 control-label text-left p-0">
              <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">ブランドからしぼる</span>
            </div>

            <div class="subject_gender_disp row">
              <div class="col-md-12 px-2 pt-0">
                <select class="form-control" v-model="search_brand" multiple>
                  <option v-for="(item, index) in brand" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                </select>
              </div>
            </div>

            <div class="cost_disp col-sm-12 mt-3 control-label text-left p-0">
              <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">料金からしぼる</span>
            </div>

            <div class="cost_disp row">
              <div class="cost_disp col-md-12 px-2 pt-0">

                <div class="col-sm-12 control-label text-left px-2 mt-3">
                  <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">商品価格</span>
                </div>

                <div class="row">
                  <div class="col-12 px-3 pt-0">
                    <select class="form-control" v-model="search_product_price">
                      <option v-for="(item, index) in product_price" :value="item.no" :key="`sort_type-${item.no}`">{{ item.name }}</option>
                    </select>
                  </div>
                </div>

              </div>
            </div>

          </template>
          <template v-if="String(main_search_type) == '2'">

            <div class="sort_disp row">
              <div class="col-md-12 px-2 pt-0">
                <select class="form-control" v-model="search_sort_type">
                  <option v-for="(item, index) in sort_type_seller" :value="item.no" :key="`sort_type-${item.no}`">{{ item.name }}</option>
                </select>
              </div>
            </div>

          </template>

          <div class="col-sm-12 mt-3 control-label text-left p-0">
            <span style="font-size: 1.1rem;font-weight: bold;color: #818181;">その他条件</span>
          </div>

          <div class="row p-3">
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_about_areas_sell" class="mr-2">全国通販可能
            </label>
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_whether_pay_installments" class="mr-2">分割払い可
            </label>
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_credit_payment" class="mr-2">クレジットカード可
            </label>
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_about_test_bullet" class="mr-2">試弾可能
            </label>
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_test_bullet_required" class="mr-2">試弾必須
            </label>
            <!--
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="" class="mr-2">保証あり
            </label>
            -->
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_about_return" class="mr-2">返品可能
            </label>
            <label class="col-md-4 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                <input type="checkbox" v-model="search_about_exchange" class="mr-2">交換可能
            </label>
          </div>

        </div>

        <div class="row text-center my-2 mx-3">
          <div class="col-md-12">
            <a href="javascript:void(0);" @click="search_detail_exec" style="color: #575757;font-size: 1rem;width: 100%;color: #fefefe;background-color: #49d04d;" class="m-0 p-2 btn search_button">検索する</a>
          </div>
          <div class="col-md-12 my-2">
            <a href="javascript:void(0);" @click="reset()" style="color: #575757;font-size: 1rem;width: 100%;" class="m-0 p-2 btn">リセットする</a>
          </div>
        </div>

      </div>
    </b-container>
  </div>

</div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
  } from 'hooper';
import 'hooper/dist/hooper.css';
import { VueLoading } from 'vue-loading-template'
import StarRating from 'vue-star-rating'
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

export default {
  name: 'Top',
	components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
    VueLoading,
    'star-rating': StarRating,
	},
  data () {
    const categories = [
      {"no":"1","img":"/static/img/upright_piano.jpg","name":"アップライトピアノ","content":"初心者向きで縦型のピアノ。ヤマハ、カワイなど。"},
      {"no":"2","img":"/static/img/grand-piano.jpg","name":"グランドピアノ","content":"本格的に弾きたい方向けのピアノ。ヤマハ、カワイなど。"},
      {"no":"3","img":"/static/img/kokyu_piano.jpg","name":"海外高級ピアノ","content":"スタインウェイ、ベーゼンドルファーなど海外高級機種"},
    ];
    const brands1 = [
      {"no":"1","img":"/static/img/yamaha.jpg","name":"ヤマハ"},
      {"no":"2","img":"/static/img/kawai.jpg","name":"カワイ"},
      {"no":"3","img":"/static/img/steinway.jpg","name":"スタインウェイ・アンド・サンズ"},
      {"no":"4","img":"/static/img/bosendorfer.jpg","name":"ベーゼンドルファー"},
    ];
    const brands2 = [
      {"no":"5","img":"/static/img/bechstein.jpg","name":"ベヒシュタイン"},
      {"no":"6","img":"/static/img/boston.jpeg","name":"ボストン"},
      {"no":"7","img":"/static/img/diapson.jpg","name":"ディアパソン"},
    ];
		const brand = [
      {"no":"1","name":"ヤマハ（YAMAHA）"},
      {"no":"2","name":"カワイ（KAWAI）"},
      {"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
      {"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
      {"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
      {"no":"6","name":"ボストン　（BOSTON）"},
      {"no":"7","name":"ディアパソン　（DIAPASON）"},
      {"no":"8","name":"アポロ　（APOLLO）"},
      {"no":"9","name":"国産ピアノ"},
      {"no":"10","name":"輸入ピアノ"},
    ];
		const gender = [
      {"no":"1","name":"男性"},
      {"no":"2","name":"女性"},
    ];

    const category = [
      {"no":"","name":"カテゴリを選択する"},
      {"no":"1","name":"アップライトピアノ"},
      {"no":"2","name":"グランドピアノ"},
      {"no":"3","name":"海外高級ピアノ"},
      {"no":"4","name":"販売者"},
    ];
		// const sort_type = [
    //   {"no":"0","name":"おすすめ順"},
    //   {"no":"1","name":"新着順"},
    //   {"no":"2","name":"現在販売中の台数順"},
    //   {"no":"3","name":"過去に販売した台数順"},
    //   {"no":"4","name":"レビュー件数順"},
    //   {"no":"5","name":"レビューの高い順"},
    //   {"no":"6","name":"お気に入りの多い順"},
    // ];
		const sort_type_product = [
      {"no":"0","name":"おすすめ順"},
      {"no":"1","name":"安い順"},
      {"no":"2","name":"高い順"},
      {"no":"3","name":"新着順"},
      {"no":"4","name":"レビュー件数順"},
      {"no":"5","name":"レビューの高い順"},
      {"no":"6","name":"お気に入りの多い順"},
      ];
		const sort_type_seller = [
      {"no":"0","name":"おすすめ順"},
      {"no":"1","name":"新着順"},
      {"no":"2","name":"現在販売中の台数順"},
      {"no":"3","name":"過去に販売した台数順"},
      {"no":"4","name":"レビュー件数順"},
      {"no":"5","name":"レビューの高い順"},
      {"no":"6","name":"お気に入りの多い順"},
      ];
    const product_price = [
      {"no":"0","name":"未選択"},
      {"no":"1","name":"～ 100,000"},
      {"no":"2","name":"100,000 ～ 200,000"},
      {"no":"3","name":"200,000 ～ 300,000"},
      {"no":"4","name":"300,000 ～ 400,000"},
      {"no":"5","name":"400,000 ～ 500,000"},
      {"no":"6","name":"500,000 ～ 600,000"},
      {"no":"7","name":"600,000 ～ 700,000"},
      {"no":"8","name":"700,000 ～ 800,000"},
      {"no":"9","name":"800,000 ～ 900,000"},
      {"no":"10","name":"900,000 ～ 1,000,000"},
      {"no":"11","name":"1,000,000 ～"},
    ];
		const type = [
      {"no":"0","name":"未選択"},
			{"no":"1","name":"グランドピアノ（GP）"},
			{"no":"2","name":"アップライトピアノ（UP）"},
    ];

    return {
      categories,
      brands1,
      brands2,

      brand,
      gender,

      category,

      // sort_type,
      sort_type_product,
      sort_type_seller,
      product_price,
      type,

      search_modal_disp: false,

      isShowExampleModal: 0,

			recommend_piano: [],
			check_piano: [],
			new_piano: [],
			new_seller: [],
			ranking_seller: [],
			ranking_piano: [],
			article: [],
			ranking_article: [],
			new_review: [],

      // 検索
      search_category: "",

      // 共通検索項目
      main_search_type: 1, // 1:ピアノ 2:販売者
      search_word: "",
      search_sort_type: 0,
      search_region_arr: [
        {"no":"","name":"都道府県を選ぶ"},
      ],
      // search_city_arr: [
      //   {"no":"0","name":"未選択"},
      // ],
      address_info: null,

      search_region: "",
      // search_city: "",
      search_about_areas_sell: false,
      search_whether_pay_installments: false,
      search_credit_payment: false,
      search_about_test_bullet: false,
      search_test_bullet_required: false,
      search_about_return: false,
      search_about_exchange: false,
      // 以下商品のみ検索項目      
      // search_state: 0,
      search_type: "0",
      search_brand: [],
      search_product_price: "0", // プルダウン
      // search_price_from: null,
      // search_price_to: null,
      // search_send_price_from: null,
      // search_send_price_to: null,
      // search_size: 0,
      // search_function: 0,
      // search_color: 0,
      // search_year: 0,

    }
  },
  methods: {
    change_search_category() {
      // {"no":"","name":"カテゴリを選択する"},
      // {"no":"1","name":"アップライトピアノ"},
      // {"no":"2","name":"グランドピアノ"},
      // {"no":"3","name":"海外高級ピアノ"},
      // {"no":"4","name":"販売者"},
      if ( this.search_category == "" ) {
        this.main_search_type = 1;
        this.search_type = "0";
        this.search_brand = [];
      } else if ( this.search_category == "1" ) {
        this.main_search_type = 1;
        this.search_type = "2";
        this.search_brand = [];
      } else if ( this.search_category == "2" ) {
        this.main_search_type = 1;
        this.search_type = "1";
        this.search_brand = [];
      } else if ( this.search_category == "3" ) {
        this.main_search_type = 1;
        this.search_type = "0";
        this.search_brand = [3,4,5];
      } else if ( this.search_category == "4" ) {
        this.main_search_type = 2;
        this.search_type = "0";
        this.search_brand = [];
      }
      this.set_address_info();
    },
    set_address_info: function() {
      this.search_region_arr = [];
      this.search_region_arr.push({
        "no":"","name":"都道府県を選ぶ",
      });
      for (let key in this.address_info[String(this.main_search_type)]) {
        this.search_region_arr.push({
          "no":key,"name":key+"("+this.address_info[String(this.main_search_type)][key]['total_count']+")", //this.pref_strring_to_code(key)
        });
      }
    },
    search_exec: function() {
      let params = {};
      params['main_search_type'] = this.main_search_type;
      if ( this.search_type != "0" ) {
        params['search_type'] = this.search_type;
      }
      if ( this.search_brand.length > 0 ) {
        params['search_brand'] = this.search_brand.join(',');
      }
      if ( this.search_region != "" ) {
        params['search_region'] = this.search_region;
      }
      this.$router.push({path: '/search', query: params});
    },
    reset() {
      this.search_category = "";
      // 共通検索項目
      this.main_search_type = 1; // 1:ピアノ 2:販売者
      this.search_word = "";
      this.search_sort_type = 0;
      this.search_region = "";
      this.search_about_areas_sell = false;
      this.search_whether_pay_installments = false;
      this.search_credit_payment = false;
      this.search_about_test_bullet = false;
      this.search_test_bullet_required = false;
      this.search_about_return = false;
      this.search_about_exchange = false;
      // 以下商品のみ検索項目      
      this.search_type = "0";
      this.search_brand = [];
      this.search_product_price = "0"; // プルダウン
      return false;
    },
    search_detail_exec: function() {
      let params = {};
      params['main_search_type'] = this.main_search_type;
      params['search_sort_type'] = this.search_sort_type;
      if ( this.search_type != "0" ) {
        params['search_type'] = this.search_type;
      }
      if ( this.search_brand.length > 0 ) {
        params['search_brand'] = this.search_brand.join(',');
      }
      if ( this.search_region != "" ) {
        params['search_region'] = this.search_region;
      }
      if ( this.search_word != "" ) {
        params['search_word'] = this.search_word;
      }
      // その他条件
      if ( this.search_about_areas_sell ) {
        params['search_about_areas_sell'] = "1";
      }
      if ( this.search_whether_pay_installments ) {
        params['search_whether_pay_installments'] = "1";
      }
      if ( this.search_credit_payment ) {
        params['search_credit_payment'] = "1";
      }
      if ( this.search_about_test_bullet ) {
        params['search_about_test_bullet'] = "1";
      }
      if ( this.search_test_bullet_required ) {
        params['search_test_bullet_required'] = "1";
      }
      if ( this.search_about_return ) {
        params['search_about_return'] = "1";
      }
      if ( this.search_about_exchange ) {
        params['search_about_exchange'] = "1";
      }

      if ( this.search_product_price != "0" ) {
        if ( this.search_product_price == "1" ) {
          params['search_price_to'] = 100000;
        } else if ( this.search_product_price == "2" ) {
          params['search_price_from'] = 100000;
          params['search_price_to'] = 200000;
        } else if ( this.search_product_price == "3" ) {
          params['search_price_from'] = 200000;
          params['search_price_to'] = 300000;
        } else if ( this.search_product_price == "4" ) {
          params['search_price_from'] = 300000;
          params['search_price_to'] = 400000;
        } else if ( this.search_product_price == "5" ) {
          params['search_price_from'] = 400000;
          params['search_price_to'] = 500000;
        } else if ( this.search_product_price == "6" ) {
          params['search_price_from'] = 500000;
          params['search_price_to'] = 600000;
        } else if ( this.search_product_price == "7" ) {
          params['search_price_from'] = 600000;
          params['search_price_to'] = 700000;
        } else if ( this.search_product_price == "8" ) {
          params['search_price_from'] = 700000;
          params['search_price_to'] = 800000;
        } else if ( this.search_product_price == "9" ) {
          params['search_price_from'] = 800000;
          params['search_price_to'] = 900000;
        } else if ( this.search_product_price == "10" ) {
          params['search_price_from'] = 900000;
          params['search_price_to'] = 1000000;
        } else if ( this.search_product_price == "11" ) {
          params['search_price_from'] = 1000000;
        }
      }

      this.$router.push({path: '/search', query: params});
    },


    // もっと
	  jumpArticleMore() {
      this.$router.push({path: '/article'});
		  return false;
	  },
	  jumpProductRanking() {
      this.$router.push({path: '/ranking', query: {type: 2}});
		  return false;
	  },
	  jumpSellerRanking() {
      this.$router.push({path: '/ranking', query: {type: 1}});
		  return false;
	  },
    // 個別
	  jumpArticleDetail(id) {
      this.$router.push({path: '/article/detail/'+String(id)});
		  return false;
	  },
	  jumpArticle(id) {
      this.$router.push({path: '/article/list/'+String(id)});
		  return false;
	  },
    jumpSearchCategory(no) {
      if (no=="1") {
        this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 0, search_type: "2"}});
      }else if (no=="2") {
        this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 0, search_type: "1"}});
      }else if (no=="3") {
        this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 0, search_brand: "3,4,5"}});
      }
      return false;
    },
    jumpSearchBrand(no) {
      this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 0, search_brand: no}});
      return false;
    },
    jumpSeller(no) {
      this.$router.push({path: '/seller/'+String(no)});
      return false;
    },
    jumpSellerNew() {
      this.$router.push({path: '/search', query: {main_search_type: 2, search_sort_type: 1}});
      return false;
    },
    jumpProductNew() {
      this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 1}});
      return false;
    },
    isSmartPhone() {
      // UserAgentからのスマホ判定
      if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return true;
      } else {
        return false;
      }
    },
		async get_top_products(type, sort) {
			this.$store.dispatch('product/get_top_products', {
        type: type,
        sort: sort,
      }).then(res => {
				console.log(res);
        let products = res.data.products;
				this.recommend_piano = products['recommend_piano'];
				this.check_piano = products['check_piano'];
				this.new_piano = products['new_piano'];
				this.new_seller = products['new_seller'];
				this.ranking_seller = products['ranking_seller'];
				this.ranking_piano = products['ranking_piano'];
				this.article = products['article'];
				this.ranking_article = products['ranking_article'];
				this.new_review = products['new_review'];
				// this.productCount = this.all_products.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
    jumpProduct(id){
      this.$router.push({path: '/product/'+id});
    }
  },
  computed: {
  },
  created() {
    noretryAuthAxios.get('/api/address_info').then(res => {
      this.address_info = res.data;
      this.set_address_info();
      // window.addEventListener('resize',this.handleResize);
      // this.handleResize();
      // if ( location.search != "" ) {
      //   this.param_to_variable();
      // }
    }).catch(error => {
      console.log('error発生');
      console.log(error);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
        });
      });
    });
    this.get_top_products(1, 1);
  },
  mounted() {
  }

}
</script>

<style scoped>

/* modal */
#overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

#overlay.search {
  z-index: 2000;
}

.search_modal {
  margin-top: 6%!important;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 30rem!important;
  background-color: #FFFFFF;
  box-shadow: 1px 1px 12px 1px rgba(164, 164, 164, 0.25);
  border-radius: 16px;
  width: 88%;
}

/* PC */
.table td, .table th, .table tr {
  color: #4A6458;
  /* border-bottom: solid 1px #231916;*/
  border-bottom: 0px solid #dedede;
}

@media screen and (max-width: 575px) {
  /* スマホ */
}

</style>



// WEBPACK FOOTER //
// src/components/Top.vue